var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('span',{staticClass:"minus"}):_c('span',{staticClass:"plus"})}
var staticRenderFns = []

export { render, staticRenderFns }